import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full space-y-2 relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex w-6 px-4 h-full absolute top-0 left-0"
}
const _hoisted_3 = { class: "m-auto text-brand-light-gray" }
const _hoisted_4 = {
  key: 0,
  class: "flex w-full"
}
const _hoisted_5 = {
  key: 0,
  class: "flex text-brand-light-gray font-medium text-xs ml-auto mr-0"
}
const _hoisted_6 = {
  key: 1,
  class: "text-brand-pink font-medium text-xs"
}

import {IonInput} from "@ionic/vue";
import {computed, ref, watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
  modelValue: {
    type: String,
  },
  placeholder: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  enterkeyhint: {
    type: String,
    default: 'return'
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  inputmode: {
    type: String,
    default: 'text'
  },
  error: {
    type: String,
    required: false
  },
  counter: {
    type: Boolean,
    default: false
  },
  clearInput: {
    type: Boolean,
    default: false
  },
  maxLength: {
    type: Number,
  },
  debounce: {
    type: Number,
    default: 0
  },
  min: {
    type: String,
    default: undefined
  },
  max: {
    type: String,
    default: undefined
  },
},
  emits: ['update:modelValue', 'onKeyEnter', 'onChange'],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit
const model = ref(props.modelValue ?? '')
const hasFocus = ref(false)

watch(() => props.modelValue, newValue =>{
  if (newValue !== undefined) model.value = newValue
})

watch(() => model.value, newValue => {
  emits('update:modelValue', newValue)
})

const focus = () => {
  hasFocus.value = true
}

const blur = () => {
  hasFocus.value = false
}

const keyPressed = (event:any) => {
  if (event.keyCode === 13) {
    emits('onKeyEnter', model)
  }
}

const characterCount = computed(() => {
  if (props.maxLength) return `${model.value.length}/${props.maxLength}`
  return model.value.length
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
          'border-brand-pink' : __props.error,
          'border-brand-lime' : hasFocus.value
        }, "flex w-full flex-col bg-brand-dark-gray rounded-lg h-14 relative border border-brand-dark-gray relative"])
    }, [
      (_ctx.$slots['icon-start'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "icon-start")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([{
            'pl-12': _ctx.$slots['icon-start'],
          }, "flex px-4 my-auto relative z-50"])
      }, [
        _createVNode(_unref(IonInput), {
          class: "text-white text-lg font-medium p-0 m-0 my-auto h-full",
          onIonFocus: focus,
          onIonBlur: blur,
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          min: __props.min,
          max: __props.max,
          "clear-input": __props.clearInput,
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "sentences",
          autofocus: __props.autofocus,
          inputmode: __props.inputmode,
          placeholder: __props.placeholder,
          onIonInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onChange', model.value))),
          onKeydown: keyPressed,
          enterkeyhint: __props.enterkeyhint,
          maxlength: __props.maxLength,
          debounce: __props.debounce,
          type: __props.type
        }, null, 8, ["modelValue", "min", "max", "clear-input", "autofocus", "inputmode", "placeholder", "enterkeyhint", "maxlength", "debounce", "type"])
      ], 2)
    ], 2),
    (__props.error || __props.counter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!__props.error && __props.counter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(characterCount.value), 1))
            : _createCommentVNode("", true),
          (__props.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.error), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})